module.exports = __webpack_public_path__ + "img/calendar.b459b659.png";